"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_MAPPER = exports.ANSWER_OPTIONS = void 0;
exports.ANSWER_OPTIONS = [true, false, null];
exports.COLOR_MAPPER = {
    neutral: 'text.caption',
    error: 'error.main',
    success: 'success.main',
};
